import { render, staticRenderFns } from "./SGPFormInputComponent.vue?vue&type=template&id=04f4a1e6&scoped=true"
import script from "./SGPFormInputComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormInputComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormInputComponent.vue?vue&type=style&index=0&id=04f4a1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4a1e6",
  null
  
)

export default component.exports